/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Terminal({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M3.246 4.951a.6.6 0 0 1 .848 0l2.625 2.625a.6.6 0 0 1 0 .848l-2.625 2.625a.599.599 0 1 1-.848-.848L5.446 8l-2.2-2.201a.6.6 0 0 1 0-.848M12.33 10.024a.6.6 0 0 1 0 1.2H7.493a.6.6 0 0 1 0-1.2z" /><path fill="currentColor" fillRule="evenodd" d="M13 .9a2.6 2.6 0 0 1 2.6 2.6v9a2.6 2.6 0 0 1-2.6 2.6H3a2.6 2.6 0 0 1-2.6-2.6v-9A2.6 2.6 0 0 1 3 .9zM3 2.1a1.4 1.4 0 0 0-1.4 1.4v9A1.4 1.4 0 0 0 3 13.9h10a1.4 1.4 0 0 0 1.4-1.4v-9A1.4 1.4 0 0 0 13 2.1z" clipRule="evenodd" /></svg>;
}
;